var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _circle2, _circle3, _circle4, _rect, _circle5, _circle6, _rect2, _circle7, _circle8, _rect3, _ellipse, _path10, _path11, _circle9, _circle10, _circle11, _circle12, _rect4, _ellipse2, _path12, _path13, _path14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCall1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 140,
    viewBox: "0 0 194 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.231445 119.686H192.123",
    stroke: "#31B047",
    strokeWidth: 0.902326
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.284 0L120.284 139.008",
    stroke: "#31B047",
    strokeWidth: 0.902326
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M135.027 69.5039L0.000313837 69.5039",
    stroke: "black",
    strokeWidth: 0.902326,
    strokeDasharray: "3.61 3.61"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1064 56.7055L19.0922 56.2546L19.0242 56.2568L18.9599 56.2788L19.1064 56.7055ZM35.5373 56.1859L35.5516 56.6368L35.639 56.6341L35.719 56.5989L35.5373 56.1859ZM51.9682 48.9593L51.8093 48.5371L51.7978 48.5414L51.7866 48.5463L51.9682 48.9593ZM66.1585 43.6165L66.1949 43.1668L66.0942 43.1586L65.9996 43.1943L66.1585 43.6165ZM84.83 45.1268L84.7937 45.5765L84.9041 45.5854L85.0061 45.5421L84.83 45.1268ZM101.261 38.16L101.225 37.7103L101.152 37.7161L101.085 37.7446L101.261 38.16ZM117.692 36.8365L117.728 37.2862L117.832 37.2778L117.922 37.2242L117.692 36.8365ZM137.133 25.2739L131.924 25.3414L134.587 29.8189L137.133 25.2739ZM0.377933 63.6118L19.2529 57.1323L18.9599 56.2788L0.0849574 62.7584L0.377933 63.6118ZM19.1207 57.1565L35.5516 56.6368L35.5231 55.7349L19.0922 56.2546L19.1207 57.1565ZM35.719 56.5989L52.1499 49.3723L51.7866 48.5463L35.3557 55.7729L35.719 56.5989ZM52.1272 49.3815L66.3175 44.0387L65.9996 43.1943L51.8093 48.5371L52.1272 49.3815ZM66.1222 44.0662L84.7937 45.5765L84.8664 44.6771L66.1949 43.1668L66.1222 44.0662ZM85.0061 45.5421L101.437 38.5754L101.085 37.7446L84.6539 44.7114L85.0061 45.5421ZM101.297 38.6097L117.728 37.2862L117.656 36.3868L101.225 37.7103L101.297 38.6097ZM117.922 37.2242L133.874 27.7373L133.412 26.9618L117.461 36.4487L117.922 37.2242Z",
    fill: "#31B047"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.231445 73.7162L19.1064 80.1958L35.5373 80.7155L51.9682 87.9421L66.1585 93.2849L84.83 91.7746L101.261 98.7414L117.692 100.065L137.133 111.627",
    stroke: "#FFD44B",
    strokeWidth: 0.902326,
    strokeDasharray: "3.61 3.61"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M147.479 72.3264C148.72 72.3264 149.467 71.7237 149.467 70.7755V70.772C149.467 69.9789 149.005 69.5489 147.948 69.3304L147.398 69.2176C146.785 69.0907 146.506 68.8792 146.506 68.5197V68.5162C146.506 68.1108 146.876 67.8324 147.472 67.8289C148.043 67.8289 148.434 68.0932 148.494 68.5373L148.501 68.5796H149.372L149.368 68.5197C149.315 67.6491 148.589 67.064 147.479 67.064C146.383 67.064 145.597 67.6703 145.593 68.5655V68.5691C145.593 69.3269 146.087 69.7921 147.088 70.0001L147.634 70.1129C148.29 70.2503 148.554 70.4548 148.554 70.8354V70.839C148.554 71.276 148.152 71.5615 147.511 71.5615C146.873 71.5615 146.425 71.2901 146.358 70.8531L146.351 70.8108H145.48L145.484 70.8636C145.544 71.7765 146.312 72.3264 147.479 72.3264ZM151.25 72.2383H152.156V67.917H153.675V67.1521H149.728V67.917H151.25V72.2383ZM154.299 72.2383H155.209V70.3349H156.192L157.193 72.2383H158.229L157.119 70.1975C157.711 69.9825 158.078 69.4291 158.078 68.7453V68.7382C158.078 67.7549 157.415 67.1521 156.329 67.1521H154.299V72.2383ZM155.209 69.6159V67.8888H156.217C156.788 67.8888 157.147 68.2131 157.147 68.7453V68.7523C157.147 69.2987 156.809 69.6159 156.234 69.6159H155.209ZM158.811 72.2383H159.72V67.1521H158.811V72.2383ZM160.615 72.2383H161.525V70.5993L162.025 70.0036L163.608 72.2383H164.715L162.681 69.3974L164.56 67.1521H163.52L161.55 69.5384H161.525V67.1521H160.615V72.2383ZM165.191 72.2383H168.483V71.4734H166.1V70.0248H168.352V69.2881H166.1V67.917H168.483V67.1521H165.191V72.2383ZM170.717 72.2383H171.627V70.557H172.677C173.706 70.557 174.408 69.8732 174.408 68.8581V68.851C174.408 67.8324 173.706 67.1521 172.677 67.1521H170.717V72.2383ZM172.451 67.8958C173.104 67.8958 173.484 68.2448 173.484 68.8546V68.8616C173.484 69.4714 173.104 69.8239 172.451 69.8239H171.627V67.8958H172.451ZM175.074 72.2383H175.983V70.3349H176.967L177.968 72.2383H179.004L177.894 70.1975C178.486 69.9825 178.852 69.4291 178.852 68.7453V68.7382C178.852 67.7549 178.19 67.1521 177.104 67.1521H175.074V72.2383ZM175.983 69.6159V67.8888H176.991C177.562 67.8888 177.922 68.2131 177.922 68.7453V68.7523C177.922 69.2987 177.583 69.6159 177.009 69.6159H175.983ZM179.585 72.2383H180.495V67.1521H179.585V72.2383ZM183.604 72.3264C184.774 72.3264 185.637 71.6038 185.768 70.5605L185.775 70.5253H184.883L184.873 70.5605C184.707 71.1879 184.252 71.5369 183.604 71.5369C182.719 71.5369 182.148 70.8249 182.148 69.6934V69.6899C182.148 68.562 182.715 67.8535 183.604 67.8535C184.266 67.8535 184.714 68.2166 184.862 68.7982L184.88 68.8651H185.771L185.768 68.8299C185.634 67.7936 184.774 67.064 183.604 67.064C182.144 67.064 181.217 68.065 181.217 69.6899V69.6934C181.217 71.3183 182.141 72.3264 183.604 72.3264ZM186.466 72.2383H189.758V71.4734H187.375V70.0248H189.627V69.2881H187.375V67.917H189.758V67.1521H186.466V72.2383Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9964 28.0657C28.6134 28.0657 29.6047 27.1184 29.6047 25.713V21.5979H28.4724V25.6204C28.4724 26.5016 27.9393 27.0788 26.9964 27.0788C26.0536 27.0788 25.5161 26.5016 25.5161 25.6204V21.5979H24.3793V25.713C24.3793 27.1184 25.3839 28.0657 26.9964 28.0657ZM30.7326 27.9556H31.8693V25.854H33.1823C34.4688 25.854 35.3456 24.9992 35.3456 23.7303V23.7215C35.3456 22.4482 34.4688 21.5979 33.1823 21.5979H30.7326V27.9556ZM32.9003 22.5275C33.7154 22.5275 34.1913 22.9637 34.1913 23.7259V23.7347C34.1913 24.4969 33.7154 24.9375 32.9003 24.9375H31.8693V22.5275H32.9003Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M148.544 41.439C149.005 41.6879 149.398 41.8317 149.729 41.9116C149.676 41.5692 149.714 41.2428 149.823 40.9461C149.835 40.894 149.851 40.8424 149.878 40.793C149.888 40.7708 149.898 40.7497 149.909 40.7297C149.91 40.7272 149.911 40.7241 149.912 40.7216C149.933 40.6822 149.959 40.6467 149.987 40.6145C150.17 40.3473 150.449 40.1511 150.781 40.0767C151.131 39.9987 151.506 40.0526 151.836 40.231C152.503 40.5923 152.791 41.3585 152.528 41.9943C152.516 42.032 152.501 42.0695 152.482 42.1056C152.481 42.1075 152.481 42.11 152.48 42.1122C152.468 42.1342 152.455 42.1555 152.436 42.1858C152.429 42.1974 152.42 42.2052 152.413 42.216C152.238 42.4924 151.993 42.7186 151.692 42.8829C151.845 42.9939 152.013 43.0913 152.195 43.1673C152.477 43.2855 152.799 43.2986 153.081 43.2997C153.686 37.5366 159.473 33.0006 166.504 33.0006C168.634 33.0006 170.738 33.4244 172.621 34.2303C173.416 33.2213 174.689 32.7109 176.415 32.7109H178.692C178.901 32.7109 179.095 32.8203 179.203 32.9993C179.311 33.1783 179.317 33.4008 179.22 33.5856L177.229 37.3695C177.208 37.4092 177.228 37.4533 177.252 37.4789C178.001 38.3059 178.609 39.2122 179.056 40.1718C179.326 40.7454 179.845 41.1023 180.41 41.1023L181.812 41.1032C182.726 41.1023 183.47 41.846 183.47 42.7599V45.8327C183.47 46.7466 182.726 47.49 181.812 47.49H180.41C179.844 47.49 179.325 47.8472 179.056 48.4225C178.338 49.9654 177.192 51.3827 175.745 52.5213C175.35 52.834 175.114 53.3385 175.114 53.8699V56.7869C175.114 57.1163 174.848 57.3835 174.518 57.3835H170.903C170.573 57.3835 170.306 57.1163 170.306 56.7869V55.1373C167.797 55.7556 165.063 55.7426 162.579 55.106V56.7868C162.579 57.1163 162.312 57.3835 161.982 57.3835L158.366 57.384C158.037 57.384 157.77 57.1168 157.77 56.7874V53.7723C157.77 53.2492 157.539 52.7494 157.156 52.438C154.549 50.3398 153.093 47.5247 153.032 44.4933C152.675 44.4903 152.205 44.465 151.737 44.2702C151.161 44.0299 150.664 43.6472 150.304 43.1857C149.592 43.1654 148.798 42.9331 147.978 42.4894C147.688 42.3326 147.58 41.9707 147.737 41.6804C147.893 41.3902 148.255 41.2811 148.545 41.439L148.544 41.439ZM151.267 41.2813C151.192 41.2402 151.11 41.2261 151.042 41.2419C151.019 41.2472 150.979 41.2599 150.96 41.296C150.96 41.2968 150.959 41.298 150.959 41.2988C150.88 41.452 150.879 41.672 150.953 41.9096C151.172 41.8327 151.34 41.7103 151.43 41.5433C151.43 41.543 151.431 41.5424 151.431 41.5422C151.455 41.4942 151.413 41.3601 151.267 41.2813Z",
    fill: "#31B047"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M162.424 49.6537L170.949 39.4238",
    stroke: "white",
    strokeWidth: 0.902326
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 169.457,
    cy: 47.9486,
    r: 1.25381,
    stroke: "white",
    strokeWidth: 0.902326
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 163.916,
    cy: 41.1288,
    r: 1.25381,
    stroke: "white",
    strokeWidth: 0.902326
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 166.686,
    cy: 31.5931,
    r: 5.59453,
    fill: "#FFD44B"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 166.686,
    cy: 31.593,
    r: 4.35131,
    fill: "url(#paint0_linear_1309_11245)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 164.884,
    y: 31.5933,
    width: 2.54862,
    height: 2.54862,
    transform: "rotate(-45 164.884 31.5933)",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.854,
    cy: 27.117,
    r: 5.59453,
    fill: "#FFD44B"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.854,
    cy: 27.1169,
    r: 4.35131,
    fill: "url(#paint1_linear_1309_11245)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 157.052,
    y: 27.1172,
    width: 2.54862,
    height: 2.54862,
    transform: "rotate(-45 157.052 27.1172)",
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 170.043,
    cy: 19.2845,
    r: 5.59453,
    fill: "#FFD44B"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 170.043,
    cy: 19.2844,
    r: 4.35131,
    fill: "url(#paint2_linear_1309_11245)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 168.24,
    y: 19.2847,
    width: 2.54862,
    height: 2.54862,
    transform: "rotate(-45 168.24 19.2847)",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 166.687,
    cy: 37.7467,
    rx: 4.47563,
    ry: 1.67836,
    fill: "#31B047"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M148.544 98.6353C149.005 98.8842 149.398 99.028 149.729 99.1079C149.676 98.7655 149.714 98.4391 149.823 98.1424C149.835 98.0903 149.851 98.0386 149.878 97.9893C149.888 97.9671 149.898 97.946 149.909 97.926C149.91 97.9235 149.911 97.9204 149.912 97.9179C149.933 97.8785 149.959 97.843 149.987 97.8108C150.17 97.5436 150.449 97.3474 150.781 97.273C151.131 97.195 151.506 97.2489 151.836 97.4273C152.503 97.7886 152.791 98.5548 152.528 99.1906C152.516 99.2283 152.501 99.2658 152.482 99.3019C152.481 99.3038 152.481 99.3063 152.48 99.3085C152.468 99.3304 152.455 99.3518 152.436 99.3821C152.429 99.3937 152.42 99.4015 152.413 99.4123C152.238 99.6887 151.993 99.9149 151.692 100.079C151.845 100.19 152.013 100.288 152.195 100.364C152.477 100.482 152.799 100.495 153.081 100.496C153.686 94.7329 159.473 90.1969 166.504 90.1969C168.634 90.1969 170.738 90.6207 172.621 91.4266C173.416 90.4176 174.689 89.9072 176.415 89.9072H178.692C178.901 89.9072 179.095 90.0166 179.203 90.1956C179.311 90.3746 179.317 90.5971 179.22 90.7819L177.229 94.5658C177.208 94.6055 177.228 94.6496 177.252 94.6752C178.001 95.5022 178.609 96.4085 179.056 97.3681C179.326 97.9417 179.845 98.2986 180.41 98.2986L181.812 98.2994C182.726 98.2986 183.47 99.0423 183.47 99.9562V103.029C183.47 103.943 182.726 104.686 181.812 104.686H180.41C179.844 104.686 179.325 105.043 179.056 105.619C178.338 107.162 177.192 108.579 175.745 109.718C175.35 110.03 175.114 110.535 175.114 111.066V113.983C175.114 114.313 174.848 114.58 174.518 114.58H170.903C170.573 114.58 170.306 114.313 170.306 113.983V112.334C167.797 112.952 165.063 112.939 162.579 112.302V113.983C162.579 114.313 162.312 114.58 161.982 114.58L158.366 114.58C158.037 114.58 157.77 114.313 157.77 113.984V110.969C157.77 110.445 157.539 109.946 157.156 109.634C154.549 107.536 153.093 104.721 153.032 101.69C152.675 101.687 152.205 101.661 151.737 101.467C151.161 101.226 150.664 100.844 150.304 100.382C149.592 100.362 148.798 100.129 147.978 99.6857C147.688 99.5289 147.58 99.167 147.737 98.8767C147.893 98.5865 148.255 98.4774 148.545 98.6353L148.544 98.6353ZM151.267 98.4776C151.192 98.4365 151.11 98.4224 151.042 98.4382C151.019 98.4435 150.979 98.4562 150.96 98.4923C150.96 98.4931 150.959 98.4942 150.959 98.4951C150.88 98.6483 150.879 98.8683 150.953 99.1059C151.172 99.029 151.34 98.9066 151.43 98.7396C151.43 98.7393 151.431 98.7387 151.431 98.7385C151.455 98.6904 151.413 98.5564 151.267 98.4776Z",
    fill: "#31B047"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M162.424 106.85L170.949 96.6206",
    stroke: "white",
    strokeWidth: 0.902326
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 169.457,
    cy: 105.145,
    r: 1.25381,
    stroke: "white",
    strokeWidth: 0.902326
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 163.916,
    cy: 98.3256,
    r: 1.25381,
    stroke: "white",
    strokeWidth: 0.902326
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 166.686,
    cy: 88.7889,
    r: 5.59453,
    fill: "#FFD44B"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 166.686,
    cy: 88.7888,
    r: 4.35131,
    fill: "url(#paint3_linear_1309_11245)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 164.884,
    y: 88.7891,
    width: 2.54862,
    height: 2.54862,
    transform: "rotate(-45 164.884 88.7891)",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 166.687,
    cy: 94.9425,
    rx: 4.47563,
    ry: 1.67836,
    fill: "#31B047"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9219 10.5308L11.3171 15.0424H16.5267L13.9219 10.5308ZM14.373 35.8049V14.5912H13.4707V35.8049H14.373Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M23.6935 102.842H26.0154C27.9187 102.842 29.0378 101.661 29.0378 99.6475V99.6387C29.0378 97.6296 27.9099 96.4841 26.0154 96.4841H23.6935V102.842ZM24.8302 101.881V97.4446H25.8964C27.1609 97.4446 27.879 98.2244 27.879 99.6431V99.6519C27.879 101.101 27.1741 101.881 25.8964 101.881H24.8302ZM32.7431 102.952C34.6024 102.952 35.7568 101.687 35.7568 99.6652V99.6563C35.7568 97.6384 34.598 96.374 32.7431 96.374C30.8927 96.374 29.7251 97.6384 29.7251 99.6563V99.6652C29.7251 101.687 30.8839 102.952 32.7431 102.952ZM32.7431 101.965C31.6064 101.965 30.8839 101.079 30.8839 99.6652V99.6563C30.8839 98.2421 31.6108 97.3609 32.7431 97.3609C33.8799 97.3609 34.6024 98.2465 34.6024 99.6563V99.6652C34.6024 101.066 33.8931 101.965 32.7431 101.965ZM37.7791 102.842H38.8761L40.1583 98.2817H40.1847L41.4668 102.842H42.5639L44.2689 96.4841H43.0882L41.9823 101.282H41.9603L40.687 96.4841H39.656L38.3827 101.282H38.3607L37.2548 96.4841H36.074L37.7791 102.842ZM45.0179 102.842H46.1503V98.3698H46.1723L49.2784 102.842H50.2918V96.4841H49.1639V100.938H49.1375L46.0401 96.4841H45.0179V102.842Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13.5352 114.595L16.1399 110.084L10.9304 110.084L13.5352 114.595ZM13.084 83.9161L13.084 110.535L13.9863 110.535L13.9863 83.9161L13.084 83.9161Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1309_11245",
    x1: 163.734,
    y1: 28.3295,
    x2: 169.794,
    y2: 34.7011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133929,
    stopColor: "#FFC200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.580357,
    stopColor: "#FFC200",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1309_11245",
    x1: 155.902,
    y1: 23.8535,
    x2: 161.962,
    y2: 30.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133929,
    stopColor: "#FFC200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.580357,
    stopColor: "#FFC200",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1309_11245",
    x1: 167.09,
    y1: 16.0209,
    x2: 173.151,
    y2: 22.3925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133929,
    stopColor: "#FFC200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.580357,
    stopColor: "#FFC200",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1309_11245",
    x1: 163.734,
    y1: 85.5253,
    x2: 169.794,
    y2: 91.8969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133929,
    stopColor: "#FFC200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.580357,
    stopColor: "#FFC200",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC200"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall1);
export default __webpack_public_path__ + "static/media/call1.1d42dac7.svg";
export { ForwardRef as ReactComponent };